module.exports = __webpack_public_path__ + "static/toy plane-58680aea0d0bd5c449d7a9b27494b04c.webp";